import { UsePaginationProps } from '@chakra-ui/react'
import { FileItem } from '@src/components/FilePreviewList/FileItem'
import { FilePreviewListStore } from '@src/components/FilePreviewList/FilePreviewListStore'
import { useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'

export const usePaginationLogic = (files: FileItem[]) => {
    const store = useLocalObservable(() => new FilePreviewListStore())

    useEffect(() => {
        store.setFiles(files)
    }, [files])

    const onPageChange: UsePaginationProps['onPageChange'] = e => {
        store.setPage(e.page)
    }

    return { store, onPageChange }
}
